import { AnimatePresence, motion } from "framer-motion";
import { cn } from "../../lib/cn";
import type { NarrationEvent } from "../../lib/types";

interface Props {
  narrations: NarrationEvent[];
}

export function NarrationLayer({ narrations }: Props) {
  if (!narrations.length) return null;
  // Only show last 3, and only errors/post with content
  const visible = narrations
    .filter((n) => n.text && n.kind !== "pre_action")
    .slice(-3);

  if (!visible.length) return null;

  return (
    <div className="my-1">
      <AnimatePresence initial={false}>
        {visible.map((n, i) => (
          <motion.div
            key={narrations.length - visible.length + i}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.12 }}
            className={cn(
              "text-[0.75rem] leading-tight px-2 py-0.5 text-fg-muted",
              n.kind === "post_action" && "text-red-400",
            )}
          >
            {n.text}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
